import type { Gradient } from '@jouzen/ecom-components';

const stressHeroGradients: Gradient[] = [
  {
    shape: 'circle',
    hex: '#A0A1D0',
    id: 'purple-1',
    position: [10, 20],
    opacity: 0.4,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#A0A1D0',
    id: 'purple-2',
    position: [99, 80],
    opacity: 0.4,
    size: 40,
  },
];

export default stressHeroGradients;
